module.exports = __webpack_public_path__ + "img/slide01.7e84e81e.jpg";